const LoggedInGuard = (state) => {
   return state.user.loggedIn
};
  
export default LoggedInGuard;
